import React from "react";
import { Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

type FormItemInfoProps = {
  labelId: string;
  label: string;
  descId?: string;
  description?: string;
};

function FormItemInfo(props: FormItemInfoProps) {
  const { labelId, label, descId, description } = props;

  return (
    <div className="pl-16">
      <Row className="mb-1">
        <h6>
          <FormattedMessage id={labelId} defaultMessage={label} />
        </h6>
      </Row>
      {(descId || description) && (
        <Row className="font-b3 text-secondary">
          <FormattedMessage id={descId} defaultMessage={description} />
        </Row>
      )}
    </div>
  );
}

export default FormItemInfo;

FormItemInfo.defaultProps = {
  descId: undefined,
  description: undefined,
};
